/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateItemTagPayload } from '../model/createItemTagPayload';
import { TagData } from '../model/tagData';
import { UpdateItemTagPayload } from '../model/updateItemTagPayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SessionTagService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create tag for the session
     * 
     * @param sessionId Session
     * @param payload Session tag to create
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSessionTag(sessionId: number, payload?: CreateItemTagPayload, observe?: 'body', reportProgress?: boolean): Observable<TagData>;
    public createSessionTag(sessionId: number, payload?: CreateItemTagPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagData>>;
    public createSessionTag(sessionId: number, payload?: CreateItemTagPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagData>>;
    public createSessionTag(sessionId: number, payload?: CreateItemTagPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling createSessionTag.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<TagData>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/tags`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete tag for the session
     * 
     * @param sessionId Session
     * @param tagId Tag id
     * @param value Tag value
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSessionTag(sessionId: number, tagId: number, value: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSessionTag(sessionId: number, tagId: number, value: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSessionTag(sessionId: number, tagId: number, value: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSessionTag(sessionId: number, tagId: number, value: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling deleteSessionTag.');
        }

        if (tagId === null || tagId === undefined) {
            throw new Error('Required parameter tagId was null or undefined when calling deleteSessionTag.');
        }

        if (value === null || value === undefined) {
            throw new Error('Required parameter value was null or undefined when calling deleteSessionTag.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/tags/${encodeURIComponent(String(tagId))}/${encodeURIComponent(String(value))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete tag for the session
     * 
     * @param sessionId Session
     * @param tagId Tag
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSessionTag1(sessionId: number, tagId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSessionTag1(sessionId: number, tagId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSessionTag1(sessionId: number, tagId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSessionTag1(sessionId: number, tagId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling deleteSessionTag1.');
        }

        if (tagId === null || tagId === undefined) {
            throw new Error('Required parameter tagId was null or undefined when calling deleteSessionTag1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/tags/${encodeURIComponent(String(tagId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List tags of a session
     * 
     * @param sessionId Session
     * @param replacePlaceholders replacePlaceholders
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSessionTagList(sessionId: number, replacePlaceholders?: boolean, observe?: 'body', reportProgress?: boolean): Observable<Array<TagData>>;
    public getSessionTagList(sessionId: number, replacePlaceholders?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TagData>>>;
    public getSessionTagList(sessionId: number, replacePlaceholders?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TagData>>>;
    public getSessionTagList(sessionId: number, replacePlaceholders?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling getSessionTagList.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (replacePlaceholders !== undefined && replacePlaceholders !== null) {
            queryParameters = queryParameters.set('replacePlaceholders', <any>replacePlaceholders);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<TagData>>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/tags`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update tag for the session
     * 
     * @param sessionId Session
     * @param payload Session tag to update
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateSessionTag(sessionId: number, payload?: UpdateItemTagPayload, observe?: 'body', reportProgress?: boolean): Observable<TagData>;
    public updateSessionTag(sessionId: number, payload?: UpdateItemTagPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TagData>>;
    public updateSessionTag(sessionId: number, payload?: UpdateItemTagPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TagData>>;
    public updateSessionTag(sessionId: number, payload?: UpdateItemTagPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling updateSessionTag.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<TagData>(`${this.basePath}/api/sessions/${encodeURIComponent(String(sessionId))}/tags`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
